import { createElementBlock as r, openBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function a(n, e) {
  return l(), r("svg", t, e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.754 6.234a2.234 2.234 0 1 1 4.467 0 2.234 2.234 0 0 1-4.467 0M11.988 2a4.234 4.234 0 1 0 0 8.467 4.234 4.234 0 0 0 0-8.467M12 12q-.175 0-.382-.005c-1.082-.02-2.761-.053-4.125 1.002C5.906 14.224 5 16.645 5 21a1 1 0 1 0 2 0c0-4.212.901-5.79 1.717-6.421.771-.597 1.697-.59 2.849-.581a55 55 0 0 0 .91-.001c.732-.008 1.371-.015 1.989.17.644.192 1.287.61 1.776 1.733a1 1 0 0 0 1.833-.8c-.722-1.656-1.822-2.487-3.036-2.85-.94-.28-1.94-.265-2.67-.254q-.2.003-.368.004m7 11a1 1 0 0 1-1-1v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 0 1-1 1M9 21a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: a };
export {
  d as default,
  a as render
};
//# sourceMappingURL=ic_register-DSw5LeA-.js.map
